import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.688rem 0 1.563rem 1.313rem',
    borderBottomColor: '#E4E7EB',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    fontSize: '1.25rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
    color: '#001d63',
  },
}));

export default function NotificationHead(props) {
  const classes = useStyles();
  return <div className={classes.root}>{props.head}</div>;
}
